/** Map identifiers shared by Studio and every render boundary. */
export const MAP_STYLE_IDS = ['mcnally', 'positron', 'relief', 'topographic', 'heat', 'moon-base', 'terra', 'blackbird'] as const;
export type MapStyleId = typeof MAP_STYLE_IDS[number];

/** Saved identifiers are converted at input boundaries; retired maps use current replacements. */
export const LEGACY_MAP_STYLE_ALIASES = {
  liberty: 'mcnally', bright: 'mcnally', fiord: 'moon-base', elevation: 'heat', 'dark-relief': 'moon-base', satellite: 'terra',
} as const satisfies Record<string, MapStyleId>;
export function normalizeMapStyle(value: unknown): MapStyleId | undefined {
  if (typeof value !== 'string') return undefined;
  return MAP_STYLE_IDS.find(id => id === value) ?? LEGACY_MAP_STYLE_ALIASES[value as keyof typeof LEGACY_MAP_STYLE_ALIASES];
}
